
import axios from 'axios'
import searchMockApi from '@/api/mock/searchMockApi'
const url = process.env.API_SEARCH_URL
var qs = require('qs')

const searchApi = {
  search (payload) {
    return axios.get(url, {
      params: {
        ...payload
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false })
      }
    }).catch(function (error) {
      console.error(error)
    })
  }
}

let api = searchApi
try {
  const useMock = process.env.NODE_ENV === 'development' && process.env.API_USE_MOCK === true
  api = useMock ? searchMockApi : searchApi
} catch (e) {
  console.error('error!')
}

export default api



// WEBPACK FOOTER //
// ./src/api/searchApi.js